export default {
  entityEditDialog: (state) => { return state.entityEditDialog },
};